'use client';

import React from 'react';
import { useAnalyticsPage } from '@/lib/hooks/useAnalyticsPage';

interface AnalyticsPageWrapperProps {
  pageName: string;
  children: React.ReactNode;
}

// This component runs the tracking hook and renders the Server Component UI (children)
export default function AnalyticsPageWrapper({
  pageName,
  children,
}: AnalyticsPageWrapperProps) {
  // Execute the client-side tracking hook
  useAnalyticsPage(pageName);

  return <>{children}</>;
}

export type { AnalyticsPageWrapperProps };
